
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Theme initialization script to prevent FOUC
const themeScript = document.createElement('script');
themeScript.innerHTML = `
  // Apply the saved theme immediately to avoid flash of incorrect theme
  (function() {
    const theme = localStorage.getItem('directpress-ui-theme') || 'system';
    
    if (theme === 'dark' || (theme === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  })();
`;
themeScript.id = 'theme-script';
document.head.prepend(themeScript);

// Create root once and render the app
const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
} else {
  console.error("Root element not found");
}
